import { GetterTree } from 'vuex';
import { TaskState } from './types';
import { RootState } from '@/store/types';
import { TaskQueryParams } from '@/api/requests/work/types';
import moment from 'moment';

export const getters: GetterTree<TaskState, RootState> = {
    /**
     * Check if task module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    taskModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('tasks');
    },

    /**
     * Get the active task.
     *
     * @param state
     * @param myGetters
     */
    activeTask: (state, myGetters) => {
        return myGetters.getTaskById(state.activeTaskId);
    },

    /**
     * Return the specified task.
     *
     * @param state
     */
    getTaskById: (state) => (id: number) => {
        return state.tasks.find((task) => task.id === id);
    },

    /**
     * Get the http query params.
     *
     * @param state
     */

    httpQueryParams: (state) => {
        return {
            start: state.filters.start ? moment(state.filters.start).format('YYYY-MM-DD HH:mm:ss') : undefined,
            end: state.filters.end ? moment(state.filters.end).format('YYYY-MM-DD HH:mm:ss') : undefined,
            work_id: state.filters.work_id ? state.filters.work_id :  undefined,
        }
    },


    /**
     * Check if task is in collection.
     *
     * @param state
     * @param myGetters
     */
    isTaskLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getTaskById(id);
    },
};
